import { useState, useEffect } from 'react';
import FamilyService from '../service/family';

export function useGetFamily() {
  const [families, setFamilies] = useState([]);

  useEffect(() => {
    FamilyService.getAll()
      .then((response) => {
        setFamilies(response.data.data);
      })
      .catch((err) => {
        console.log('err: ' + err);
      });
  }, []);

  return {
    families,
    setFamilies
  };
}
